import { Dialog, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import FormInput from "../molecules/FormInput";
import useRefresh from "../../hooks/useRefresh";
import FormTemplate from "../templates/FormTemplate";
import { ApiService, UserService } from "../../services/api";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

interface CreateApiDialogProps {
  open: boolean;
  onClose?: () => void;
}

export default function CreateApiDialog(props: CreateApiDialogProps) {
  const { t } = useTranslation("CreateApiDialog");
  const refresh = useRefresh();
  const [description, setDescription] = useState("");
  const [user, setUser] = useState("");
  const [allowedIps, setAllowedIps] = useState<string[]>([]);

  const { data: users, isLoading: loadingUsers } = useQuery({
    queryKey: ["user-mini-list"],
    queryFn: async () => {
      const res = await UserService.getPrivilegedUserList();
      return res.data.data;
    },
  });

  useEffect(() => {
    if (!props.open) return;
    setDescription("");
    setUser("");
    setAllowedIps([]);
  }, [props.open]);

  const handleSubmit = async () => {
    const res = await ApiService.createAPI({
      createAPIBody: {
        description,
        user,
        allowedIps,
        enabled: true,
      },
    });
    if (res?.data?.success) {
      refresh();
      props.onClose?.();
    }
  };
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <FormTemplate
        title={t("CreateApi")}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
        confirm
      >
        <Stack spacing={2} sx={{ minWidth: { xs: 300, sm: 500 } }}>
          <FormInput
            field="description"
            label={t("Description")}
            onChange={(v) => {
              setDescription(v as string);
            }}
            placeholder={t("DescriptionPlaceholder")}
            type="string"
            value={description}
            required
          />
          <FormInput
            field="user"
            label={t("User")}
            onChange={(v) => {
              setUser(v as string);
            }}
            placeholder={t("SelectUserPlaceholder")}
            list={(users || []).map((user) => ({
              name: user.name,
              value: user._id || "",
            }))}
            type="list"
            value={user}
            loading={loadingUsers}
            required
          />
          <FormInput
            field="allowedIps"
            label={t("AllowedIps")}
            value={allowedIps}
            placeholder={t("AllowedIpsPlaceholder")}
            type="chip-list"
            onChange={(v) => {
              setAllowedIps(v as string[]);
            }}
          />
        </Stack>
      </FormTemplate>
    </Dialog>
  );
}
